import React from 'react';
import { useTranslation } from 'react-i18next';
import './DCChargingLoader.css';

export default function DCChargingLoader() {
  const { t } = useTranslation();
  const steps = t('dcChargingLoader.steps')
    .split(' > ')
    .map(step => step.trim())
    .filter(Boolean);

  return (
    <div className="dc-charging-loader">
      <div className="dc-charging-loader-arrows" aria-hidden="true">
        <span>&gt;</span>
        <span>&gt;</span>
        <span>&gt;</span>
      </div>
      <p className="dc-charging-loader-status">{t('dcChargingLoader.starting')}</p>
      <div className="dc-charging-loader-content">
        <div className="dc-charging-loader-text">
          <p className="dc-charging-loader-title">{t('dcChargingLoader.title')}</p>
          <p className="dc-charging-loader-lead">{t('dcChargingLoader.lead')}</p>
          {steps.map((step, index) => (
            <p key={step} className="dc-charging-loader-step">
              {index > 0 ? (
                <span className="dc-charging-loader-arrow" aria-hidden="true">
                  &gt;
                </span>
              ) : null}
              {step}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}
